import React from "react";
import StatItemUI, { StatItemProps } from "../atoms/StatItemUI";
import { X } from "lucide-react";

interface StatsUIProps {
  title: string;
  stats: StatItemProps[];
  onClose?: () => void;
}

// Función classNames para combinar clases condicionalmente
function classNames(...classes: (string | undefined)[]): string {
  return classes.filter(Boolean).join(" ");
}

const StatsUI: React.FC<StatsUIProps> = ({ title, stats, onClose }) => {
  return (
    <div className="p-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold leading-6 text-xl text-gray-500">
          {title}
        </h3>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
          <X />
        </button>
      </div>
      <dl
        className={`mt-5 mb-3 grid ${
          stats.length === 1 ? "grid-cols-1" : "grid-cols-1 md:grid-cols-3"
        } gap-0`}
      >
        {stats.map((item) => (
          <div key={item.name} className="border border-gray-200">
            <div key={item.name} className="px-4 py-5 sm:p-6">
              <dt className="text-base font-normal text-gray-900">
                {item.name}
              </dt>
              <dd className="mt-1 flex items-baseline justify-between md:block lg:flex">
                <div className="flex items-baseline text-2xl font-semibold text-primary-600">
                  {item.stat}
                </div>

                <div className="bg-green-100 text-green-800">%</div>
              </dd>
            </div>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default StatsUI;
